var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19399 2.10203C7.26833 1.95147 7.3833 1.82471 7.52591 1.73607C7.66852 1.64744 7.83308 1.60046 8.001 1.60046C8.16891 1.60046 8.33347 1.64744 8.47608 1.73607C8.61869 1.82471 8.73366 1.95147 8.80799 2.10203L10.329 5.18403L13.73 5.67803C13.8963 5.70201 14.0525 5.77204 14.181 5.8802C14.3095 5.98837 14.4052 6.13034 14.4573 6.29007C14.5093 6.44979 14.5156 6.62089 14.4754 6.784C14.4352 6.94711 14.3502 7.09572 14.23 7.21303L11.768 9.61303L12.349 13C12.3772 13.1655 12.3586 13.3356 12.2953 13.491C12.2319 13.6465 12.1264 13.7811 11.9905 13.8798C11.8547 13.9784 11.6939 14.037 11.5265 14.0491C11.3591 14.0612 11.1916 14.0261 11.043 13.948L8.001 12.35L4.95899 13.95C4.81025 14.0283 4.64254 14.0634 4.47488 14.0513C4.30722 14.0391 4.14631 13.9803 4.01037 13.8814C3.87443 13.7825 3.76891 13.6476 3.70574 13.4918C3.64258 13.336 3.62431 13.1657 3.65299 13L4.23299 9.61303L1.77299 7.21403C1.65277 7.09679 1.56775 6.94825 1.52753 6.78522C1.48732 6.62218 1.49352 6.45114 1.54543 6.29144C1.59735 6.13175 1.69291 5.98976 1.8213 5.88153C1.9497 5.77331 2.10581 5.70316 2.27199 5.67903L5.67199 5.18503L7.19399 2.10303V2.10203Z",
    fill: "#FFBF1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/iconStar.4a57894f4ba84b47fadaa3de3a7955e9.svg";
export { ForwardRef as ReactComponent };